import { useDebounceTextChange } from "~/client/components/search/hooks/useDebounceTextChange";
import type { UserType } from "~/client/components/shared/UserAvatarWithPopup";
import { useGetSearchResultLazyQuery } from "~/client/generated/schema";
import type { ConnectionWithTotalCount } from "~/client/utils/relay";
import { emptyConnection } from "~/client/utils/relay";

export interface NoteAndCommentItem {
  readonly path: string;
  readonly titleHtml: string;
  readonly contentUpdatedAt: string;
  readonly contributors: ConnectionWithTotalCount<UserType>;
  readonly document: { __typename: "Note" | "Comment" | "CommentReply" };
}

export const useNoteAndCommentSearchResult = (query: string, debounceTime: number = 500) => {
  const [search, { data, loading }] = useGetSearchResultLazyQuery();

  const [changing] = useDebounceTextChange(
    (query) => {
      search({ variables: { query } });
    },
    query,
    debounceTime,
  );

  return {
    items: (data?.search as ConnectionWithTotalCount<NoteAndCommentItem>) || emptyConnection<NoteAndCommentItem>(),
    isLoading: loading || changing,
  };
};
